import { defineStore } from 'pinia'

import ApiServiceV1 from '../api/adminApi/AdminApiV1'
import RetailApiV2 from '../api/retailApi/RetailApiV2'
import type { Product } from '@/types/product'

interface IFilterItem {
  permalink?: string
  title?: string
  systemName?: string
  label?: string
}

interface IProductStore {
  propertiesFilters: IFilterItem[]
  categoriesFilters: IFilterItem[]
  sort: unknown | null
  crossSell: unknown | null
  goodDeeds: unknown | null
  product: undefined | null
  currentPage: number
  perPage: number
}

export const useProductStore = defineStore('productStore', {
  state: (): IProductStore => ({
    propertiesFilters: [],
    categoriesFilters: [],
    crossSell: null,
    sort: 'best_selling',
    goodDeeds: null,
    product: null,
    currentPage: 1,
    perPage: 12
  }),

  actions: {
    setPage(page: number) {
      this.currentPage = page
    },
    setPerPage(amount: number) {
      this.perPage = amount
    },
    setFilter(filters: IFilterItem[]) {
      this.propertiesFilters = filters
    },
    setCategoryFilter(filters: IFilterItem[]) {
      this.categoriesFilters = filters
    },
    setSort(sort: string) {
      this.sort = sort
    },
    clearFilters() {
      this.propertiesFilters = []
      this.categoriesFilters = []
    },
    toggleFilter(filter: IFilterItem) {
      if (this.propertiesFilters.includes(filter)) {
        this.propertiesFilters = this.propertiesFilters.filter((item) => item !== filter)
      } else {
        this.propertiesFilters.push(filter)
      }
      this.currentPage = 1;
    },
    toggleCategoryFilter(filter: IFilterItem) {
      if (this.categoriesFilters.includes(filter)) {
        this.categoriesFilters = this.categoriesFilters.filter((item) => item !== filter)
      } else {
        this.categoriesFilters.push(filter)
      }
      this.currentPage = 1;
    },
    async loadCrossSell(params: string) {
      return (await RetailApiV2.get(`cross_sell_products?${params}`)).data?.cross_sell_products ?? null
    },
    async loadMostSearchedWords(params: string) {
      return (await RetailApiV2.get(`search/top_searches?${params}`)).data?.mostSearched ?? null
    },
    async loadGoodDeeds(onlyAvailable: boolean) {
      const { data } = await ApiServiceV1.get('products?permalink=dobre-skutky')

      if (onlyAvailable) {
        return data.products.filter((product: Product) => product.state === 'available')
      }
      return data.products
    },
  },

  getters: {
    getPropertiesFilters: (state) => state.propertiesFilters,
    getCategoriesFilters: (state) => state.categoriesFilters,
    getCurrentPage: (state) => state.currentPage,
    getPerPage: (state) => state.perPage,
    getSort: (state) => state.sort,
    filterCount: (state) => state.propertiesFilters.length + state.categoriesFilters.length,
    isInFilter: (state) => (filter: IFilterItem) => state.propertiesFilters.includes(filter) || state.categoriesFilters.includes(filter),
  },
})
